export default "__VITE_ASSET__C6OE2kWj__"